import { ChangeEvent, FC, KeyboardEvent, useState } from 'react'

import { Display, TextField, typography } from '@joor/design-system'
import styled from 'styled-components'

import {
  AgGridFilterComparison,
  AgGridFilterType,
  FilterOptionProps,
} from 'features/Orders/components'

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px;
  ${typography.alpha.primaryActive.body3}
`

const StyledTextField = styled(TextField)`
  width: 88px;
  padding-right: 12px;
`

enum FilterLimit {
  max = 'max',
  min = 'min',
}

export type NumberFilterProps = FilterOptionProps & {
  currencySymbol?: string
  limitValues: { [FilterLimit.min]: number; [FilterLimit.max]: number }
  onRemoveFilter: (name: string) => void
}

export const NumberFilter: FC<NumberFilterProps> = ({
  name,
  currencySymbol = '',
  limitValues,
  onUpdateFilters,
  onRemoveFilter,
  ...props
}) => {
  const [value, setValue] = useState({
    [FilterLimit.min]: '',
    [FilterLimit.max]: '',
  })

  const handleChange =
    (limit: FilterLimit) =>
    (event: ChangeEvent<HTMLInputElement>): void => {
      setValue((state) => ({
        ...state,
        [limit]: event.target.value,
      }))
    }

  const handleSubmit = (): void => {
    if (!value[FilterLimit.min] && !value[FilterLimit.max]) {
      onRemoveFilter(name)
      return
    }

    onUpdateFilters(name, {
      filter: value[FilterLimit.min]
        ? Number(value[FilterLimit.min])
        : limitValues[FilterLimit.min],
      filterTo: value[FilterLimit.max]
        ? Number(value[FilterLimit.max])
        : limitValues[FilterLimit.max],
      filterType: AgGridFilterType.Number,
      type: AgGridFilterComparison.InRange,
      ...(currencySymbol ? { currencySymbol } : {}),
    })
  }

  const handleKeyPress = (event: KeyboardEvent<HTMLInputElement>): void => {
    if (event.key !== 'Enter') return

    handleSubmit()
  }

  return (
    <Display>
      <Container {...props}>
        <StyledTextField
          placeholder={`${limitValues[
            FilterLimit.min
          ].toString()}${currencySymbol}`}
          onChange={handleChange(FilterLimit.min)}
          onKeyPress={handleKeyPress}
        />
        to
        <StyledTextField
          placeholder={`${limitValues[
            FilterLimit.max
          ].toString()}${currencySymbol}`}
          onChange={handleChange(FilterLimit.max)}
          onKeyPress={handleKeyPress}
        />
      </Container>
    </Display>
  )
}
